import { TextField, makeStyles, Typography, TextFieldProps } from '@material-ui/core'
import StyledIconWithTooltip from './StyledIconWithTooltip'
import { FONT_WEIGHTS } from '../../utils'
import { gray } from '../../utils/colors'
import { useRef } from 'react'

const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		'& .MuiTextField-root': {
			minWidth: 'unset',
			minHeight: 'unset',
			'& .MuiFilledInput-underline': {
				minWidth: 'unset',
				'& > input': {
					minHeight: 'unset',
					height: 'unset'
				}
			}
		}
	},
	headerContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '.5rem'
	},
	header: {
		fontFamily: 'Nunito',
		fontSize: '0.75rem',
		color: gray[900],
		textTransform: 'uppercase',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		letterSpacing: '0.0625rem'
	},
	viewOnlyContainer: {
		backgroundColor: gray[200],
		borderRadius: '6px',
		borderBottomLeftRadius: 0,
		borderTopRightRadius: 0,
		height: '55px',
		padding: '0 12px',
		display: 'flex',
		alignItems: 'center',
		fontFamily: 'Nunito',
		fontWeight: 400,
		fontSize: '1rem',
		color: gray[800]
	},
	charcounter: {
		fontSize: '0.75rem',
		fontFamily: 'Nunito',
		color: gray[600],
		marginTop: '0.5rem',
		fontWeight: 600
	}
}))

/**
 * Pass in any TextField props to this component to render a styled TextField.
 *
 * props.header is optional and will render a header above the TextField
 *
 * props.charcounter is optional and will render a character counter below the TextField, requires inputProps.maxLength to be set
 *
 * props.select is optional and will render a select input instead of a text input
 *
 * props.viewonly is optional and will render the value in a view only container div that mimics the shape of the TextField
 * @param {TextFieldProps & {header?: string | undefined, charcounter?: boolean viewonly?: boolean, tooltip?: {tooltipChildren?: JSX.Element, tooltipText?: string, faIcon?: string}}} props
 * @returns
 */
const StyledTextField = (props) => {
	const classes = useStyles()
	const inputRef = useRef(null)
	return (
		<div className={classes.container}>
			{props.header ? (
				props.tooltip && !props.disabled ? (
					<span className={classes.headerContainer}>
						<Typography variant="overline">{props.header}</Typography>
						<StyledIconWithTooltip
							placement={props.tooltip.placement || 'right-start'}
							tooltipChildren={props.tooltip.tooltipChildren || undefined}
							tooltipText={props.tooltip.tooltipText || ''}
							faIcon={props.tooltip.faIcon || undefined}
							skiptownvariant={props.tooltip.skiptownvariant || undefined}
						/>
					</span>
				) : (
					<Typography variant="overline">{props.header}</Typography>
				)
			) : null}
			{props.viewonly ? (
				<div className={classes.viewOnlyContainer}>{props.value}</div>
			) : (
				<>
					<TextField inputRef={inputRef} {...props} viewonly="overwrite" charcounter="overwrite" />
					{props.charcounter && props.inputProps?.maxLength ? (
						<span className={classes.charcounter}>
							{inputRef.current?.value?.length || props.value?.length || 0} /{' '}
							{props.inputProps?.maxLength} Max Characters
						</span>
					) : null}
				</>
			)}
		</div>
	)
}

export default StyledTextField
